import React, { useEffect } from "react";

const DicomViewer = () => {
  useEffect(() => {
    // Initialize Cornerstone
    // cornerstone.enable(document.getElementById("dicom-container"));
    // Load DICOM image (replace 'path/to/dicom/file' with your actual file path)
    // cornerstone.loadImage("path/to/dicom/file").then((image) => {
    //   cornerstone.displayImage(
    //     document.getElementById("dicom-container"),
    //     image
    //   );
    // });
    // Add any additional tools or configurations as needed
  }, []);

  return (
    <div id="dicom-container" style={{ width: "100%", height: "100vh" }}></div>
  );
};

export default DicomViewer;
